import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '../../assets/icons/chevron.svg?react';
import type { NavItem } from './HeaderNavItem';
import styles from './HeaderNav.module.css';

interface HeaderNavGhostProps {
  items: NavItem[];
  listRef: RefObject<HTMLUListElement | null>;
}

// A hidden, unclickable copy of the complete navigation, kept only so widths
// can be measured (see useNavOverflow). It mirrors the real bar's markup and
// classes, including a stand-in for the overflow trigger, so the measurements
// match what the bar would look like fully expanded.
export const HeaderNavGhost = ({ items, listRef }: HeaderNavGhostProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.navGhostClip} aria-hidden="true">
      <ul ref={listRef} className={styles.navGhost}>
        {items.map((item) => (
          <li key={item.labelKey}>
            <span className={styles.navLink}>{t(item.labelKey)}</span>
          </li>
        ))}
        <li>
          <span className={styles.navLink}>
            {t('nav-more')}
            <ChevronIcon className={styles.moreChevron} />
          </span>
        </li>
      </ul>
    </div>
  );
};
